"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Pagination = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactPaginate = _interopRequireDefault(require("react-paginate"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./style.scss");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withMapping = _interopRequireDefault(require("../../Context/withMapping"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Pagination = function Pagination(_ref) {
  var currentPage = _ref.currentPage,
      totalPages = _ref.totalPages,
      pageRangeDisplayed = _ref.pageRangeDisplayed,
      marginPagesDisplayed = _ref.marginPagesDisplayed,
      setCurrentPage = _ref.setCurrentPage,
      previousLabel = _ref.previousLabel,
      nextLabel = _ref.nextLabel,
      containerClassName = _ref.containerClassName,
      disabledClassName = _ref.disabledClassName,
      activeClassName = _ref.activeClassName,
      breakClassName = _ref.breakClassName,
      showWhenOnePage = _ref.showWhenOnePage;

  var pageChange = function pageChange(data) {
    if (setCurrentPage) {
      setCurrentPage(data.selected + 1);
    }
  };

  if (totalPages === 0) {
    return null;
  }

  if (totalPages === 1 && !showWhenOnePage) {
    return null;
  }

  if (currentPage > totalPages) {
    currentPage = totalPages;
  }

  if (!previousLabel || !nextLabel) {
    previousLabel = /*#__PURE__*/_react.default.createElement("a", {
      className: "Pagination__previous__icon"
    });
    nextLabel = /*#__PURE__*/_react.default.createElement("a", {
      className: "Pagination__next__icon"
    });
  }

  var containerClasses = (0, _classnames.default)('Pagination__container', containerClassName);
  var breakClasses = (0, _classnames.default)('Pagination__break', breakClassName);
  var disabledClasses = (0, _classnames.default)('disabled', disabledClassName);
  var activeClasses = (0, _classnames.default)('active', activeClassName);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "Pagination"
  }, /*#__PURE__*/_react.default.createElement(_reactPaginate.default, {
    previousLabel: previousLabel,
    nextLabel: nextLabel,
    breakLabel: "...",
    breakClassName: breakClasses,
    pageCount: totalPages,
    pageRangeDisplayed: pageRangeDisplayed,
    marginPagesDisplayed: marginPagesDisplayed,
    disabledClassName: disabledClasses,
    initialPage: currentPage - 1,
    onPageChange: pageChange,
    containerClassName: containerClasses,
    activeClassName: activeClasses
  }));
};

exports.Pagination = Pagination;
Pagination.propTypes = {
  currentPage: _propTypes.default.number.isRequired,
  totalPages: _propTypes.default.number.isRequired,
  pageRangeDisplayed: _propTypes.default.number,
  marginPagesDisplayed: _propTypes.default.number,
  setCurrentPage: _propTypes.default.func,
  previousLabel: _propTypes.default.string,
  nextLabel: _propTypes.default.string,
  containerClassName: _propTypes.default.string,
  disabledClassName: _propTypes.default.string,
  activeClassName: _propTypes.default.string,
  showWhenOnePage: _propTypes.default.bool
};
Pagination.defaultProps = {
  setCurrentPage: null,
  previousLabel: null,
  nextLabel: null,
  containerClassName: null,
  disabledClassName: null,
  activeClassName: null,
  pageRangeDisplayed: 5,
  marginPagesDisplayed: 1,
  showWhenOnePage: false
};

var _default = (0, _withMapping.default)(Pagination);

exports.default = _default;